import React from 'react';
import { lightColors } from '../../../theme';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  const { stroke } = props;
  return (
    <Svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.52856 4H3.94026H15.2339"
        stroke={stroke || lightColors.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.05798 4.00016V2.66683C6.05798 2.31321 6.20671 1.97407 6.47145 1.72402C6.7362 1.47397 7.09527 1.3335 7.46968 1.3335H10.2931C10.6675 1.3335 11.0265 1.47397 11.2913 1.72402C11.556 1.97407 11.7048 2.31321 11.7048 2.66683V4.00016M13.8223 4.00016V13.3335C13.8223 13.6871 13.6736 14.0263 13.4088 14.2763C13.1441 14.5264 12.785 14.6668 12.4106 14.6668H5.35213C4.97772 14.6668 4.61865 14.5264 4.35391 14.2763C4.08916 14.0263 3.94043 13.6871 3.94043 13.3335V4.00016H13.8223Z"
        stroke={stroke || lightColors.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.46973 7.3335V11.3335"
        stroke={stroke || lightColors.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.293 7.3335V11.3335"
        stroke={stroke || lightColors.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
